
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/feedbacks",
      function () {
        return require("private-next-pages/admin/feedbacks.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/feedbacks"])
      });
    }
  